
export default {
  mounted: async function () {
    await this.getOtherNews();
  },

  data: function () {
    return {
      news: [],
    }
  },

  props: {
    newsId: {
      type: [String, Number],
      default: ""
    },
  },

  computed: {
    newsList: function () {
      return [...this.news].filter((t) => t.id !== this.newsId)
    }
  },

  methods: {
    getOtherNews: async function () {
      const tag = this.$store.state.appState?.vars?.['Наименование тега для прочих статей'];
      let res = await this.$api.agent.transport.get(`/articles?filter[category_slug]=articles&per-page=4`).then((res) => {
        return res.data
      }).catch(() => {
        return []
      });
      this.news = res;
    },
  }
}
